import Axios from 'axios';
import { config } from '../../config/Constants';


export const getSelectData = async (data) => {
    try {
      const response = await Axios.get(config.url.GET_SELECT_DATA, {
        params: {
          selectValues: data.selectValues,
          tableName: data.tableName,
          whereField: data.whereField,
          whereValue: data.whereValue,
          orderBy: data.orderBy,
          db: data.db
        }
      });
      return response.data.dataResults; 
    } catch (error) {
      console.log('Error fetching select fields', error);
      return [];
    }
  }

  export const getDynamicSelectData = async (data) => {
    try {
      const whereValue =
        typeof data.getWhereValue === "function"
          ? data.getWhereValue()
          : data.whereValue;

      if (!whereValue?.[0]) return [];
      const response = await Axios.get(config.url.GET_DYNAMIC_SELECT_DATA, {
        params: {
          selectValues: data.selectValues,
          tableName: data.tableName,
          whereField: data.whereField,
          whereOperators: data.whereOperators,
          whereValue,
          orderBy: data.orderBy,
          offset: data.offset,
          db: data.db,
        }
      });
      return response.data.dataResults; 
    } catch (error) {
      console.log('Error fetching select fields', error);
      return [];
    }
  }
